import axios from '../../axios'
import { functions, renderExecuteServerEventAPIData } from './ApplicationAPI/applicationApi';
import {getFormId, getGdToken,getMicroFrontendDataToken, getReduxContexts, getShowAlertNotificationFromStore,getWIToken, parentFrameMappedId} from './IFormDesignerLogic'
import cloneDeep from 'lodash-es/cloneDeep';
import iforms from './Request';
import { getHooksId } from '../../Resources/globalFunctions';

export function jsonElementOperation(jsonToSend, operationType, postHook){
    //call the loader method here
    var newJsonToSend = cloneDeep((jsonToSend));
    var controllerUrl;
    if(operationType==='save'){
        controllerUrl='/idesign/saveFormState';
        newJsonToSend.formName='testForm';
    } else if(operationType==='getFormStateFromJson'){
        controllerUrl='/idesign/getFormStateFromJson';
    } else if(operationType==='getFormStateFromXml'){
        controllerUrl='/idesign/';
    } else if(operationType==='preview'){
        newJsonToSend.wdModelKey='HotFix-0000000098-process_1';
        newJsonToSend.generalDataKey='HotFix-0000000098-process_GeneralData';
        newJsonToSend.FromApplication='pms';
          controllerUrl='/viewform/';
    } else if(operationType==='getAttributeXml'){
          controllerUrl = "/viewform/getAttributeXml/";
    }
      let formId = getFormId()
    jsonToSend.formId = formId?.toString();
      return axios.post(controllerUrl, newJsonToSend, {
        withCredentials: true,
      });
}

export function generateJsonToSend(formJsonData,targetId, jsonToSend){
    if(jsonToSend===undefined) jsonToSend={};
    try {
        if(Array.isArray(formJsonData)){
            formJsonData.forEach((item,index)=>{
                if(item["id"] && item["id"]===targetId){
                    jsonToSend = conditionalJsonToSendCreator(item, jsonToSend);
                    return jsonToSend;
                } else 
                if(Object.keys(item).includes("children")){
                    jsonToSend = conditionalJsonToSendCreator(item, jsonToSend);
                    generateJsonToSend(item,targetId, jsonToSend);
                }
            })
        } else{
            if(formJsonData["id"] && formJsonData["id"]===targetId){
                jsonToSend = conditionalJsonToSendCreator(formJsonData, jsonToSend);
                return jsonToSend;
            } else 
            if(formJsonData["children"]){
                generateJsonToSend(formJsonData["children"],targetId, jsonToSend);
            }
        }
    }
    catch(error) {
    }
    return jsonToSend;
}

function conditionalJsonToSendCreator(formJsonData, jsonToSend){
    try{
        if(jsonToSend===undefined) jsonToSend={};
        if(formJsonData.elem_type==='frame' || formJsonData.elem_type==='section'){
            if(jsonToSend.elem_type ){
                //case when we are looking up for a section within a section or a section within a tab
            } else {
                jsonToSend.elem_type = 'section';
                jsonToSend.id = formJsonData.id;
                jsonToSend.frameIndex = formJsonData.frameIndex;
            }
        }

    }catch(err){
         console.log(err);
    }
    return jsonToSend;
}

export async function sendRequestToUpdateValue(jsonToSend, frameIndex, containerId, controlName = "")
{
    try{
        const reduxContexts = getReduxContexts();
        const { formState2 } = reduxContexts;
        let parentFrameMapped = parentFrameMappedId(formState2, jsonToSend?.attrName, frameIndex)
        if(parentFrameMapped && parentFrameMapped?.dataclass){
          jsonToSend.sectionKeyField = parentFrameMapped?.style?.SectionKeyField
          jsonToSend.sectionKeyValue = parentFrameMapped?.style?.SectionKeyValue
        }
        jsonToSend.witoken=getWIToken(containerId);
        jsonToSend.gdtoken=getGdToken(containerId);

        var remainingURL= controlName === "tile" ? '/viewform/updateAttributeValueForTile' : '/viewform/updateAttributeValue';

        
        const sendUpdateRes= await axios.post(remainingURL, jsonToSend,{withCredentials:true, headers: {
          }})
        .then((res) => {
            if(res?.data?.error === "Y") {
                const showAlert = getShowAlertNotificationFromStore()
                showAlert({
                    'open':true,
                    'showConfirm':'showNotification',
                    'alertType':'error',
                    'alertContentKey': "There is some issue at server end. Kindly check with system administrator."
                });
            }
            // if(res?.data?.APIData) {
            //     renderExecuteServerEventAPIData({outputArray: res?.data?.APIData, sync: true});
            // }
            window.setFormMoified(true);
            if(window.formChangeHook){
                const domControlElement=document.getElementById(`${jsonToSend['attrName']}`)
                console.log(`domControlElement ${jsonToSend['attrName']}`,domControlElement)
                window.formChangeHook(domControlElement,`${jsonToSend['attrName']}`)
                functions.updateJSON();
            }
            return res;
        
        });
        return sendUpdateRes;
    }
    catch(err)
    {
         console.log(err);
    }
}

export function saveTableData(jsonToSend){
    try{
        var remainingURL='viewform/getAttributeXml';
        return axios.post(remainingURL, jsonToSend,{withCredentials:true});
    }catch(error){
        console.log(error)
    }
}

export function saveTableDataInPortal(jsonToSend){
    try{
        return axios.post("/viewform/saveApplicationData",jsonToSend,{withCredentials:true})
    }catch(error){
        console.log(error)
    }
}

export function fetchFilterData(jsonToSend, gridJson){
    try{
        var remainingURL='/tableAction/filterData';
        return axios.post(remainingURL, jsonToSend,{withCredentials:true})
        .then((response) => {
            if(window.searchGridPostHook){
                window.searchGridPostHook(getHooksId(gridJson) || jsonToSend.controlId);
                functions.updateJSON();
            }
            return response
        });;
    }catch(error){
        console.log(error)
    }
}

export const sendRequestForMarvinAPI = async (jsonToSend = {}, controller) => {
  try {
    const remainingURL = "/idesign/gptResponse";
    return axios.post(remainingURL, jsonToSend, {
      withCredentials: true,
      ...(controller ? { signal: controller.signal } : {})
    });
  } catch (error) {
    console.log("marvin Error", error);
  }
};

export function fetchFilterDataPortal(jsonToSend){
    try{
        var remainingURL='/tableAction/fetchBatch';
        return axios.post(remainingURL, jsonToSend,{withCredentials:true});
    }catch(error){
        console.log(error)
    }
}

export function sendRequestForPageTemplate(jsonToSend){

    try{
        var remainingURL='/idesign/loadPageTemplate';
        return axios.post(remainingURL, jsonToSend,{withCredentials:true});
    }
    catch(err)
    {
         console.log(err);
    }

}
export function fetchRichTextEditorData(jsonToSend)
{
    try{
        var remainingURL='/viewform/fetchRichTextEditorData';
        return axios.post(remainingURL, jsonToSend,{withCredentials:true});
    }
    catch(err)
    {
         console.log(err);
    }
}
export function deleteRowInGrid(jsonToSend,sync)
{
   try{
    jsonToSend.witoken=getWIToken();
    jsonToSend.gdtoken=getGdToken();
    var remainingURL='/tableAction/deleteRow';
    if(sync) {
      iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, sync);
      return iforms.ajax.strResponse;
    }
    else {
      return axios.post(remainingURL, jsonToSend,{withCredentials:true});
    }
   }
   catch(err)
    {
         console.log(err);
    }
}

export function getRichTxtData(jsonToSend)
{
   try{
      var remainingURL='/viewform/fetchRichTextEditorData';
      iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, true);
      return iforms.ajax.strResponse;
   }
   catch(err)
    {
         console.log(err);
    }
}

export function saveRTEData(jsonToSend)
{
   try{
      var remainingURL='/viewform/saveRichTextEditorData';
      iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, true);
      return iforms.ajax.strResponse;
   }
   catch(err)
    {
         console.log(err);
    }
}

export function getGeneralData(jsonToSend)
{
   try{
      var remainingURL='/viewform/getGeneralDataJSON';
      iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, true);
      return iforms.ajax.strResponse;
   }
   catch(err)
    {
         console.log(err);
    }
}

export function clearTable(jsonToSend,sync)
{
    try{
        jsonToSend.witoken=getWIToken();

        jsonToSend.gdtoken=getGdToken();
        var remainingURL='/tableAction/clearTable';
        if(sync) {
          iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, sync);
          return iforms.ajax.strResponse;
        } else {
          return axios.post(remainingURL, jsonToSend,{withCredentials:true});
        } 
       }
       catch(err)
        {
             console.log(err);
        }
}
export function addRowInGrid(jsonToSend,sync)
{
    try{
        jsonToSend.witoken=getWIToken();

        jsonToSend.gdtoken=getGdToken();
        var remainingURL='/tableAction/addRow';
        if(sync) {
          iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, sync);
          return iforms.ajax.strResponse;
        }
        else {
          return axios.post(remainingURL, jsonToSend,{withCredentials:true});          
        }
       }
       catch(err)
        {
             console.log(err);
        }
}
export function setValues(jsonToSend,sync)
{
    try{
        jsonToSend.witoken=getWIToken();

        jsonToSend.gdtoken=getGdToken();
        var remainingURL='/viewform/setValues';
        if(sync) {
          iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, sync);
          if(iforms?.ajax?.objReq){
            if(iforms?.ajax?.objReq?.response && iforms?.ajax?.objReq?.status === 400){
              let a = JSON.parse(iforms?.ajax?.objReq?.response);
              a["failed"] = true
              return a;
            }
          }
          return iforms.ajax.strResponse;
        }
        else {
          return axios.post(remainingURL, jsonToSend,{withCredentials:true});
        }
       }
       catch(err)
        {
             console.log(err);
        }
}

export function deleteDoc(jsonToSend,sync)
{
    try{
        jsonToSend.witoken=getWIToken();
        jsonToSend.gdtoken=getGdToken();
        var remainingURL='/viewform/deleteDoc';
        if(sync) {
          iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, sync);
          return iforms.ajax.strResponse;
        }
        else {
          return axios.post(remainingURL, jsonToSend,{withCredentials:true});
        }
       }
       catch(err)
        {
             console.log(err);
        }
}

export function addDataToGrid(jsonToSend,sync)
{
    try{
        jsonToSend.witoken=getWIToken();

        jsonToSend.gdtoken=getGdToken();
        var remainingURL='/tableAction/addDataToGrid';
        if(sync) {
          iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, sync);
          return iforms.ajax.strResponse;
        } else {
          return axios.post(remainingURL, jsonToSend,{withCredentials:true});          
        }
       }
       catch(err)
        {
             console.log(err);
        }
}

export function saveApplicationData1(jsonToSend,sync)
{
    try{
        // jsonToSend.witoken=getWIToken();

        // jsonToSend.gdtoken=getGdToken();
        var remainingURL="/viewform/saveApplicationData";
        if(sync) {
          iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, sync);
          return iforms.ajax.strResponse2;
        } else {
          return axios.post(remainingURL, jsonToSend,{withCredentials:true});          
        }
       }
       catch(err)
        {
             console.log(err);
        }
}

export function addDataToAdvancedGrid(jsonToSend,sync)
{
    try{
        jsonToSend.witoken=getWIToken();

        jsonToSend.gdtoken=getGdToken();
        var remainingURL='/tableAction/addDataToAdvancedGrid';
        if(sync) {
          iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, sync);
          return iforms.ajax.strResponse;
        }
        else {
          return axios.post(remainingURL, jsonToSend,{withCredentials:true});
        }
       }
       catch(err)
        {
             console.log(err);
        }
}

export function setTableCellData(jsonToSend,sync)
{
    try{
        jsonToSend.witoken=getWIToken();

        jsonToSend.gdtoken=getGdToken();
        
        var remainingURL='/tableAction/setTableCellData';
        if(sync) {
          iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, sync);
          return iforms.ajax.strResponse;
        } else {
          return axios.post(remainingURL, jsonToSend,{withCredentials:true});          
        }
       }
       catch(err)
        {
             console.log(err);
        }
}
export function setTableMultiCellData(jsonToSend,sync)
{
    try{
        jsonToSend.witoken=getWIToken();

        jsonToSend.gdtoken=getGdToken();
        var remainingURL='/tableAction/setTableMultiCellData';
        if(sync) {
          iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, sync);
          return iforms.ajax.strResponse;
        } else {
          return axios.post(remainingURL, jsonToSend,{withCredentials:true});
        }
       }
       catch(err)
        {
             console.log(err);
        }
}

export function getSessionId(jsonToSend)
{
    try{
        jsonToSend.gdtoken=getGdToken();
        var remainingURL='/viewform/getSessionId';
        return axios.post(remainingURL, jsonToSend,{withCredentials:true});
       }
       catch(err)
        {
             console.log(err);
        }
}

export function validateCustomControlId(jsonToSend)
{
    try{
        let formId = getFormId()
        jsonToSend.formId = formId.toString()
        var remainingURL='/idesign/validateCustomControlId';
        return axios.post(remainingURL, jsonToSend,{withCredentials:true});
       }
       catch(err)
        {
             console.log(err);
        }
}

export function disconnectUser(jsonToSend) {
  try {
    var remainingURL = "/disconnectUser";
    return axios.post(remainingURL, jsonToSend, { withCredentials: true });
  } catch (err) {
     console.log(err);
  }
}

export function initializeSubForm(jsonToSend) {
  try {
    let formId = getFormId()
    jsonToSend.formId = formId.toString()
    var remainingURL = "/idesign/initializeSubForm";
    return axios.post(remainingURL, jsonToSend, { withCredentials: true });
  } catch (err) {
     console.log(err);
  }
}

export function saveSubForm(jsonToSend) {
  try {
    let formId = getFormId()
    jsonToSend.formId = formId.toString()
    var remainingURL = "/idesign/saveSubForm";
    return axios.post(remainingURL, jsonToSend, { withCredentials: true });
  } catch (err) {
     console.log(err);
  }
}


export function reloadTab(jsonToSend,sync)
{
    try{
        jsonToSend.witoken=getWIToken();
        jsonToSend.gdtoken=getGdToken();
        var remainingURL='/viewform/reloadTabSheet';
        if(sync) {
          iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, sync);
          return iforms.ajax.strResponse;
        } else {
          return axios.post(remainingURL, jsonToSend,{withCredentials:true});          
        }
       }
       catch(err)
        {
             console.log(err);
        }
}

export function refreshFrame(jsonToSend,sync)
{
    try{
        jsonToSend.witoken=getWIToken();
        jsonToSend.gdtoken=getGdToken();
        var remainingURL='/viewform/refreshFrame';
        if(sync) {
          iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, sync);
          return iforms.ajax.strResponse;
        } else {
          return axios.post(remainingURL, jsonToSend,{withCredentials:true});
        }
       }
       catch(err)
        {
             console.log(err);
        }
}

export function executeServerEvent(jsonToSend,sync)
{
    try{
        jsonToSend.witoken=getWIToken();
        jsonToSend.gdtoken=getGdToken();
        var remainingURL='/viewform/executeServerEvent';
        if(sync) {
          iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, sync);
          return iforms.ajax.strResponse;
        }
        else {
          return axios.post(remainingURL, jsonToSend,{withCredentials:true});
        }
       }

       catch(err)
        {
             console.log(err);
        }

}

export function changePortalLang(lang) {
  try {
      var remainingURL='/viewform/changeLocale';
      const jsonToSend = {
        locale: lang
      }
      iforms.ajax.processRequest(JSON.stringify(jsonToSend), remainingURL, true);
      return iforms.ajax.strResponse;
  }
  catch(err)
  {
    console.log(err);
  }
}

export function executeDBLinking(jsonToSend)

{

    try{

        jsonToSend.witoken=getWIToken();

        jsonToSend.gdtoken=getGdToken();

        var remainingURL='/viewform/executeDBLinking';

        return axios.post(remainingURL, jsonToSend,{withCredentials:true});

       }

       catch(err)

        {

             console.log(err);

        }

}

export function executeCustomService(jsonToSend)
{

    try{

       jsonToSend.witoken=getWIToken();

        jsonToSend.gdtoken=getGdToken();

        var remainingURL='/viewform/executeCustomService';

        return axios.post(remainingURL, jsonToSend,{withCredentials:true});

       }

       catch(err)
        {
             console.log(err);
        }
}

export function getAttributeXml(jsonToSend)
{

    try{

       jsonToSend.witoken=getWIToken();

        jsonToSend.gdtoken=getGdToken();

        var remainingURL='/viewform/getAttributeXml';

        return axios.post(remainingURL, jsonToSend,{withCredentials:true});

       }

       catch(err)

        {

             console.log(err);

        }
}

export function fetchTableChildren(jsonToSend){

    try{
        let formId = getFormId()
        jsonToSend.formId = formId.toString()
        var remainingURL='/idesign/gettableDefinition';
        return axios.post(remainingURL, jsonToSend,{withCredentials:true});
    }
    catch(err)
    {
         console.log(err);
    }

}


export function mappingExistOrNot(jsonToSend){
    try{
        let formId = getFormId()
        jsonToSend.formId = formId.toString()
        var remainingURL='/idesign/MappingExist';
        
        return axios.post(remainingURL, jsonToSend,{withCredentials:true});
    }
    catch(err)
    {
         console.log(err);
    }
}

export function removeMapping(jsonToSend){
    try{
        let formId = getFormId()
        jsonToSend.formId = formId.toString()
        var remainingURL='/idesign/removeMapping';
        
        return axios.post(remainingURL, jsonToSend,{withCredentials:true});
    }
    catch(err)
    {
         console.log(err);
    }
}

function isWizardOrMenu(val){
    if(val==="wizard_h" || val==="wizard_v" || val==="sidenavigation" || val==="Menu"){
        return true
    }
    else{
        return false;
    }
}

export function initializeAdvanceListviewForm(jsonToSend = {}) {
    
    try {
      var remainingURL = isWizardOrMenu(jsonToSend?.containerControl) || jsonToSend.isAdvLVInMenu ? "/idesign/initializeAdvanceListviewInStep" : "/idesign/initializeAdvanceListview";
      let formId = getFormId();
      jsonToSend.formId = formId.toString();
      return axios.post(remainingURL, jsonToSend, { withCredentials: true });
    } catch (err) {
       console.log(err);
    }
  }

  export function saveAdvanceListview(jsonToSend) {
    try {
        let formId = getFormId()
        jsonToSend.formId = formId.toString()
      var remainingURL = "/idesign/saveAdvanceListview";
      return axios.post(remainingURL, jsonToSend, { withCredentials: true });
    } catch (err) {
       console.log(err);
    }
  }


  export function addRowAdvanceListview(jsonToSend){
    try {
        var remainingURL = "/tableAction/setAttributeInSession";
        return axios.post(remainingURL, jsonToSend, { withCredentials: true });
      } catch (err) {
         console.log(err);
      }
  }

  export function setListViewRowIndexInAdvListView(jsonToSend){
    try {
        var remainingURL = "/tableAction/setAttributeInSession";
        return axios.post(remainingURL, jsonToSend, { withCredentials: true });
      } catch (err) {
         console.log(err);
      }
  }

  export function sendSaveAndClose(jsonToSend){
    try {
        var remainingURL = "/tableAction/addRowInAdvListview";
        return axios.post(remainingURL, jsonToSend, { withCredentials: true });
    } catch (err) {
         console.log(err);
      }
  }


  export function modifyCallForAdvanceListview(jsonToSend){
    try {
        var remainingURL = "/tableAction/modifyRowInAdvListview";
        return axios.post(remainingURL, jsonToSend, { withCredentials: true });
    } catch (err) {
         console.log(err);
      }
  }



  export function fetchProcessModularData(jsonToSend){
    
    try{
        let formId = getFormId()
        jsonToSend.formId = formId.toString()
        var remainingURL='/idesign/getprocessVariable';
        return axios.post(remainingURL, jsonToSend, {withCredentials:true});
    }
    catch(err)
    {
         console.log(err);
    }
}

export function fetchProcessTaskTemplate(jsonToSend){
    try{
        let formId = getFormId()
        jsonToSend.formId = formId.toString()
        var remainingURL='/idesign/getTaskTemplateVariables';
        return axios.post(remainingURL, jsonToSend, {withCredentials:true});
    }
    catch(err)
    {
         console.log(err);
    }
}

export function fetchProcessGlobalTemplate(jsonToSend){
    try{
        let formId = getFormId()
        jsonToSend.formId = formId.toString()
        var remainingURL='/idesign/getGlobalTemplateVariables';
        return axios.post(remainingURL, jsonToSend, {withCredentials:true});
    }
    catch(err)
    {
         console.log(err);
    }
}

export function clearAdvanceListview(jsonToSend) {
    try {
      var remainingURL = "/tableAction/clearAdvancedListviewMap";
      return axios.post(remainingURL, jsonToSend, { withCredentials: true });
    } catch (err) {
       console.log(err);
    }
  }


  export function userDefinedThemes()
  {
      try{
          var remainingURL='/idesign/getUserDefinedThemes';
          return axios.post(remainingURL, {withCredentials:true});
         }
         catch(err)
          {
              console.log(err);
          }
  }  


  export function systemDefinedThemes()
  {
      try{
          var remainingURL='/idesign/getSystemDefinedThemes';
          return axios.post(remainingURL, {withCredentials:true});
         }
         catch(err)
          {
              console.log(err);
          }
  }  


  export function saveTheme(jsonToSend)
  {
      try{
        let formId = getFormId()
        jsonToSend.formId = formId.toString()
          var remainingURL='/idesign/saveTheme';
          return axios.post(remainingURL, jsonToSend, {withCredentials:true});
         }
         catch(err)
          {
              console.log(err);
          }
  }  

  export function deleteTheme(jsonToSend)
  {
      try{
        let formId = getFormId()
        jsonToSend.formId = formId.toString()
          var remainingURL='/idesign/deleteTheme';
          return axios.post(remainingURL, jsonToSend, {withCredentials:true});
         }
         catch(err)
          {
              console.log(err);
          }
  } 

  // Create a map of month abbreviations to month numbers
  const monthMap = {
    "Jan": 0, "Feb": 1, "Mar": 2, "Apr": 3,
    "May": 4, "Jun": 5, "Jul": 6, "Aug": 7,
    "Sep": 8, "Oct": 9, "Nov": 10, "Dec": 11
  };

  const DateSeperator = { "1": "/", "2": "-", "3": "." };

  export const dateStrintToObject = (dateString, format, dateSeparators) => {
    let dateObject = "";

    const { dateSeparatorNo, dateTimeSeparatorNo } = dateSeparators;
    const dateSeparator = DateSeperator[dateSeparatorNo];
    const dateTimeSeparator = DateSeperator[dateTimeSeparatorNo];

    if(dateString && format) {
      if(format === "1") {
        const dateParts = dateString.split(dateSeparator);
        dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
      }
      else if (format === "2") {
        dateObject = new Date(dateString);
      }
      else if (format === "3") {
        dateObject = new Date(dateString);
      }
      else if (format === "4") {
        const dateParts = dateString.split(dateSeparator);

        // Extract day, month, and year from the array
        const day = parseInt(dateParts[0], 10);
        const month = monthMap[dateParts[1]];
        const year = parseInt(dateParts[2], 10);

        // Create a new Date object using the extracted values
        dateObject = new Date(year, month, day);
      }
      else if (format === "5") {
        // Split the date-time string into date and time parts
        const [datePart, timePart] = dateString.split(" ");

        // Split the date part into day, month, and year
        const [day, month, year] = datePart.split(dateTimeSeparator).map(Number);

        // Split the time part into hours, minutes, and seconds
        const [hours, minutes, seconds] = timePart.split(":").map(Number);

        // Create a new Date object using the extracted values
        dateObject = new Date(year, month - 1, day, hours, minutes, seconds);
      }
      else if (format === "6") {
        // Split the date-time string into date and time parts
        const [datePart, timePart] = dateString.split(" ");

        // Split the date part into month, day, and year
        const [month, day, year] = datePart.split(dateTimeSeparator).map(Number);

        // Split the time part into hours, minutes, and seconds
        const [hours, minutes, seconds] = timePart.split(":").map(Number);

        // Create a new Date object using the extracted values
        dateObject = new Date(year, month - 1, day, hours, minutes, seconds);
      }
      else if (format === "7") {
        // Split the date-time string into date and time parts
        const [datePart, timePart] = dateString.split(" ");

        // Split the date part into year, month, and day
        const [year, month, day] = datePart.split(dateTimeSeparator).map(Number);

        // Split the time part into hours, minutes, and seconds
        const [hours, minutes, seconds] = timePart.split(":").map(Number);

        // Create a new Date object using the extracted values
        dateObject = new Date(year, month - 1, day, hours, minutes, seconds);
      }
      else if (format === "8") {
        // Split the date-time string into date and time parts
        const [datePart, timePart] = dateString.split(" ");

        // Split the date part into day, month, and year
        const day = parseInt(datePart.split(dateTimeSeparator)[0], 10);
        const monthAbbreviation = datePart.split(dateTimeSeparator)[1];
        const year = parseInt(datePart.split(dateTimeSeparator)[2], 10);

        // Get the month number from the monthMap
        const month = monthMap[monthAbbreviation];

        // Split the time part into hours, minutes, and seconds
        const hours = parseInt(timePart.split(":")[0], 10);
        const minutes = parseInt(timePart.split(":")[1], 10);
        const seconds = parseInt(timePart.split(":")[2], 10);

        // Create a new Date object using the extracted values
        dateObject = new Date(year, month, day, hours, minutes, seconds);
      }
    }

    return dateObject;
  }

  export function sortGrid(columnStyle = {}, rowData = [], columnIndex = 0, batchType = "A", formState2 = {}) {
    if (!rowData.length) {
      return rowData;
    }
    const clonedRowData = cloneDeep(rowData);
    const updatedRowData = [...clonedRowData];
    const isDate = columnStyle.ColumnType === "datepick" || columnStyle.ColumnType === "datetimepick";
  
    const isStringMapped =
      columnStyle.complexFieldType === "String" ||
      columnStyle.complexFieldType === "NText" ||
      !columnStyle.complexFieldType;
  
    const isNumberMapped =
      columnStyle.complexFieldType === "Integer" ||
      columnStyle.complexFieldType === "Float" ||
      columnStyle.complexFieldType === "Long";
  
    if (isNumberMapped && !isDate) {
      updatedRowData.sort((a, b) => {
        let numA, numB;
        if (columnStyle.complexFieldType === "Float") {
          numA = a?.[columnIndex]?.value ? parseFloat(a[columnIndex].value) : 0; // ignore upper and lowercase
          numB = b?.[columnIndex]?.value ? parseFloat(b[columnIndex].value) : 0; // ignore upper and lowercase
        } else {
          numA = a?.[columnIndex]?.value ? parseInt(a[columnIndex].value) : 0; // ignore upper and lowercase
          numB = b?.[columnIndex]?.value ? parseInt(b[columnIndex].value) : 0; // ignore upper and lowercase
        }
  
        const sub = numA - numB;
  
        if (sub < 0) {
          if (batchType === "A") {
            return -1;
          } else {
            return 1;
          }
        }
        if (sub > 0) {
          if (batchType === "A") {
            return 1;
          } else {
            return -1;
          }
        }
  
        // names must be equal
        return 0;
      });
    } else if (isStringMapped && !isDate) {
      updatedRowData.sort((a, b) => {
        const nameA = a?.[columnIndex]?.value ? a[columnIndex].value.toUpperCase() : "";
        const nameB = b?.[columnIndex]?.value ? b[columnIndex].value.toUpperCase() : "";
  
        if (nameA < nameB) {
          if (batchType === "A") {
            return -1;
          } else {
            return 1;
          }
        }
        if (nameA > nameB) {
          if (batchType === "A") {
            return 1;
          } else {
            return -1;
          }
        }
  
        // names must be equal
        return 0;
      });
    } else if(columnStyle.complexFieldType === "Boolean" && !isDate) {
      updatedRowData.sort((a, b) => {
        const nameA = a?.[columnIndex]?.value ? a[columnIndex].value.toString() : "";
        const nameB = b?.[columnIndex]?.value ? b[columnIndex].value.toString() : "";
  
        if (nameA < nameB) {
          if (batchType === "A") {
            return -1;
          } else {
            return 1;
          }
        }
        if (nameA > nameB) {
          if (batchType === "A") {
            return 1;
          } else {
            return -1;
          }
        }
  
        // names must be equal
        return 0;
      });
    } else {
      const dateSeparatorNo = formState2?.theme?.InputStyle?.DateSeperator || "1";
      const dateTimeSeparatorNo = formState2?.theme?.InputStyle?.DateTimeSeperator || "1";
      const themeDateFormat = formState2?.theme?.InputStyle?.ThemeDateFormat || "1";
      const themeDateFormat2 = formState2?.theme?.InputStyle?.ThemeDateFormat2 || "5";

      let dateFormat = columnStyle.DateFormat;
      if(!dateFormat) {
        if(columnStyle.ColumnType === "datepick") {
          dateFormat = themeDateFormat;
        }
        if(columnStyle.ColumnType === "datetimepick") {
          dateFormat = themeDateFormat2;
        }
      }

      updatedRowData.sort((a, b) => {
        const nameA = a?.[columnIndex]?.value || "";
        const nameB = b?.[columnIndex]?.value || "";
  
        const dateA = dateStrintToObject(nameA, dateFormat, { dateSeparatorNo, dateTimeSeparatorNo });
        const dateB = dateStrintToObject(nameB, dateFormat, { dateSeparatorNo, dateTimeSeparatorNo });
  
        const sub = dateA - dateB;
  
        if (sub < 0) {
          if (batchType === "A") {
            return -1;
          } else {
            return 1;
          }
        }
        if (sub > 0) {
          if (batchType === "A") {
            return 1;
          } else {
            return -1;
          }
        }
  
        // names must be equal
        return 0;
      });
    }
    return updatedRowData;
  }

  export function uploadImageAPI(jsonToSend) {
    try {
      const remainingURL = jsonToSend.isBase64 ? "/idesign/uploadImageContent" : "/idesign/uploadImage";
      const imageKey = jsonToSend.isBase64 ? "imageContent" : "file";
      const formData = new FormData();
      let formId = getFormId()
      formData.append(imageKey, jsonToSend.imageObject);  
      formData.append("applicationName", encodeURIComponent(jsonToSend.applicationName));
      formData.append("formName", encodeURIComponent(jsonToSend.formName));
      formData.append("formId", encodeURIComponent(formId.toString()));
      formData.append("pageName", encodeURIComponent(jsonToSend?.pageName));
      formData.append("subPageName", encodeURIComponent(jsonToSend?.subPageName))
  
      return axios.post(remainingURL, formData, {
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    } catch (err) {
      console.log(err);
    }
  }

  export function exportToPDF({ formName, imageData, height, width }) {
  formName = formName.replace(" ", "");
  let newFormName = "";

  if (window.downloadPDFWithName) {
    newFormName = window.downloadPDFWithName(formName);
  }

  const url =
    `${window.apb_backend_app_context}/DownloadPDF?FormName=${newFormName || formName}` +
    "&tiffFlag=false&location=" + encodeURIComponent("");

  // Create a real form
  const form = document.createElement("form");
  form.method = "POST";
  form.action = url;
  form.target = "_blank";
  form.enctype = "application/x-www-form-urlencoded";

  // Hide using a CSS class instead of inline style
  form.classList.add("hidden-pdf-form");

  // Add fields
  const pdfCont = document.createElement("input");
  pdfCont.type = "hidden";
  pdfCont.name = "pdfCont";
  pdfCont.value = imageData;

  const formWidth = document.createElement("input");
  formWidth.type = "hidden";
  formWidth.name = "formWidth";
  formWidth.value = width;

  const formHeight = document.createElement("input");
  formHeight.type = "hidden";
  formHeight.name = "formHeight";
  formHeight.value = height;

  form.append(pdfCont, formWidth, formHeight);
  document.body.appendChild(form);

  form.submit();
  form.remove();
}
  







  

